import React from 'react'
import { Grid, Header, Container, Divider } from 'semantic-ui-react'
import NavBar from './NavBar'
import PlayerQuestionResult from './PlayerQuestionResult'
import { EndedMatch } from './PlayerPage'

const CenterHeader = ({ children }) => <Header style={{ textAlign: 'center' }}>{children}</Header>

const rightAnsweredQuestion = {
    text: 'text: testo della domanda',
    topic: 'topic: argomento',
    answer: 'answer: risposta',
    bet: 15,
    gain: Math.round(15 * 1.53),
    balance: 65,
    quote: 1.53
}

const wrongAnsweredQuestion = {
    text: 'text: testo della domanda',
    topic: 'topic: argomento',
    answer: 'answer: risposta',
    bet: 15,
    gain: 0,
    balance: 65,
    quote: 1.53
}

const blackAnsweredQuestion = {
    text: 'text: testo della domanda',
    topic: 'topic: argomento',
    answer: 'answer: risposta',
    bet: 15,
    gain: -65,
    balance: 65,
    quote: 1.53
}

export default () => (
    <div>
        <NavBar />
        <Container>
            <CenterHeader>EndedMatch</CenterHeader>
            <Grid columns={2}>
                <Grid.Column>
                    <Header>primo</Header>
                    <EndedMatch firstPlayer={{ username: 'PrimoClassificato'}} position={0} numPlayers={37} />
                </Grid.Column>
                <Grid.Column>
                    <Header>dodicesimo</Header>
                    <EndedMatch firstPlayer={{ username: 'PrimoClassificato'}} position={11} numPlayers={37} />
                </Grid.Column>
            </Grid>

            <CenterHeader>PlayerQuestionResult</CenterHeader>
            <Grid columns={2}>
                <Grid.Row>
                    <Grid.Column>
                        <Header>risposta giusta</Header>
                        <PlayerQuestionResult question={rightAnsweredQuestion} isCompleted />
                    </Grid.Column>
                    <Grid.Column>
                        
                        <Header>risposta sbagliata</Header>
                        <PlayerQuestionResult question={wrongAnsweredQuestion} isCompleted />
                        
                        <Divider hidden />
                        
                        <Header>black answer</Header>
                        <PlayerQuestionResult question={blackAnsweredQuestion} isCompleted />

                    </Grid.Column>
                </Grid.Row>
            </Grid>
        </Container>
    </div>
)


// WEBPACK FOOTER //
// ./src/components/KitchenSink.js